import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "ErrorMessage"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: _ctx.widgetId }, null, 8 /* PROPS */, _hoisted_1),
    (_ctx.showErrorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " We're having trouble verifying you are a human. Please try again. "))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}